export interface Resource {
  id: string;
  name: string;
  quantity: number;
  unit: string;
  category: 'seed' | 'fertilizer' | 'pesticide' | 'tool' | 'other';
  minimum_quantity?: number;
  location?: string;
  expiry_date?: string;
  notes?: string;
  user_id: string;
  created_at: string;
}

export interface ResourceState {
  resources: Resource[];
  loading: boolean;
  error: string | null;
}

export interface ResourceCategory {
  value: Resource['category'];
  label: string;
}

export const RESOURCE_CATEGORIES: ResourceCategory[] = [
  { value: 'seed', label: 'Seeds' },
  { value: 'fertilizer', label: 'Fertilizers' },
  { value: 'pesticide', label: 'Pesticides' },
  { value: 'tool', label: 'Tools' },
  { value: 'other', label: 'Other' }
];